<template>
  <div id="login">
    <el-container class="page_login">
      <el-main>
        <div id="header-wrapper" class="header-wrapper">
          <div class="header">
            <div class="left-header" id="left-header">
              <img
                src="../../assets/img/home/2d1b12f6db56a8c30a67c8dc18d3ff9d@2x.png"
                class="new-logo"
              />
              <!-- <span style="margin-left: 5px; font-size: 15px"
                >晓评学生评价</span
              > -->
              <!-- <img src="../../assets/img/home/logo.png" class="header-logo" /> -->
              <ul class="nav">
                <li>
                  <span class="nav-span" @click="scrollTo('welcome')"
                    >首页</span
                  >
                </li>
                <li>
                  <span class="nav-span" @click="scrollTo('production')"
                    >产品功能</span
                  >
                </li>

                <li>
                  <span class="nav-span" @click="scrollTo('value')"
                    >产品价值</span
                  >
                </li>
                <li>
                  <span class="nav-span" @click="scrollTo('four')"
                    >四大亮点</span
                  >
                </li>
                <li>
                  <span class="nav-span" @click="scrollTo('case')"
                    >成功案例</span
                  >
                </li>

                <li>
                  <span class="nav-span" @click="scrollTo('connect')"
                    >联系咨询</span
                  >
                </li>
              </ul>
            </div>
            <div class="right-header">
              <div class="login-wrapper">
                <button
                  class="login-button hover-blue"
                  @click="loginShow = !loginShow"
                >
                  登录
                </button>
              </div>
            </div>
          </div>
        </div>
        <section id="welcome" class="welcome-wrapper">
          <div class="intro">
            <h2 class="title">助力学校综合素质评价工作<br />校本化落地实施</h2>
            <div class="df">
              <div class="download-box left-box df df-c ai-c">
                <a
                  class="download-button hover-blue"
                  href="https://cdn.51xiaoping.com/download/pcxp/%E6%99%93%E8%AF%84%E7%BB%BC%E5%90%88%E8%AF%84%E4%BB%B7Setup.exe"
                >
                  立即下载
                </a>
              </div>
              <div class="download-box right-box df df-c ai-c">
                <div class="download-qrcode-text">微信小程序</div>
              </div>
            </div>
          </div>
          <!-- <video
            ref="bgVideo"
            src="https://cdn.51xiaoping.com/Video/public/xiaoping.mp4"
            class="bg-video"
            muted
            autoplay
            loop
          ></video> -->
        </section>
        <!-- <section id="video" class="video-section slidein-item slidein">
          <div class="df jc-sb">
            <div class="video-left">
              <div class="video-text">
                <img
                  class="video-text-img"
                  src="../../assets/img/home/video-text-1.png"
                />
              </div>
              <div class="video-text vt-right">
                <img
                  class="video-text-img"
                  src="../../assets/img/home/video-text-2.png"
                />
              </div>
              <div class="video-button" @click="videoPlay"></div>
            </div>
            <div class="video-box">
              <video
                ref="bgVideo"
                src="https://cdn.51xiaoping.com/Video/public/xiaoping.mp4"
                class="bg-video"
                controls
              ></video>
            </div>
          </div>
        </section> -->
        <section id="production" class="production-section">
          <div class="section-title">
            产品功能
            <img
              src="../../assets/img/home/title-label.png"
              class="title-label"
            />
          </div>
          <div class="pro-title">
            八大应用场景——<span
              >涵盖过程性评价和结果评价，和课后服务、劳动实践、研学等业务深度结合，真正做到校园、家庭、社会评价闭环，助力“双减”政策有效落地，推动“家校共育”。</span
            >
          </div>
          <div class="df jc-sb slidein-item slidein ai-c" id="proT">
            <div class="production-img">
              <img :src="proUrl(teacherIndex)" />
            </div>
            <div>
              <div class="production-title">教师端</div>
              <div class="df production-box">
                <div
                  class="production-item"
                  v-for="(item, index) in functionTList"
                  :key="item.name"
                  :class="teacherIndex == index ? 'bg-active' : ''"
                  @mouseenter="teacherIn(index)"
                  @mouseleave="teacherOut"
                >
                  <div
                    class="item-title"
                    :class="teacherIndex == index ? 'item-active' : ''"
                  >
                    {{ item.name }}
                  </div>
                  <div
                    class="item-line"
                    :class="teacherIndex == index ? 'line-active' : ''"
                  ></div>
                  <div
                    class="item-text"
                    :class="teacherIndex == index ? 'item-active' : ''"
                  >
                    {{ item.text }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="df jc-sb slidein-item slidein ai-c parent-box" id="proS">
            <div>
              <div class="production-title">家长端</div>
              <div class="df production-box">
                <div
                  class="production-item"
                  v-for="(item, index) in functionSList"
                  :key="item.name"
                  :class="studentIndex == index ? 'bg-active' : ''"
                  @mouseenter="studentIn(index)"
                  @mouseleave="studentOut"
                >
                  <div
                    class="item-title"
                    :class="studentIndex == index ? 'item-active' : ''"
                  >
                    {{ item.name }}
                  </div>
                  <div
                    class="item-line"
                    :class="studentIndex == index ? 'line-active' : ''"
                  ></div>
                  <div
                    class="item-text"
                    :class="studentIndex == index ? 'item-active' : ''"
                  >
                    {{ item.text }}
                  </div>
                </div>
              </div>
            </div>
            <div class="production-img">
              <img :src="prosUrl(studentIndex)" />
            </div>
          </div>
        </section>
        <div id="value" class="slidein-item slidein" style="padding-top: 70px">
          <section class="value-section slidein-item slidein">
            <div class="value-wrapper">
              <div class="section-title" style="color: #fff">
                产品价值
                <img
                  src="../../assets/img/home/title-label-w.png"
                  class="title-label"
                />
              </div>
              <div class="df ai-c jc value-items">
                <div class="df df-c ai-c value-item">
                  <img
                    src="../../assets/img/home/value-0.png"
                    class="value-img"
                  />
                  <div class="title">对局端</div>
                  <div class="text">
                    数据诊断—科学决策<br />
                    <span
                      >建设区域“双减”背景下的学生综合<br />
                      素质评价体系，打造区域特色</span
                    >
                  </div>
                </div>
                <div class="df df-c ai-c value-item">
                  <img
                    src="../../assets/img/home/value-1.png"
                    class="value-img"
                  />
                  <div class="title">对学校</div>
                  <div class="text">
                    校本化实施—一校一品<br />
                    <span
                      >学校综合发展报告，为学校发展“问<br />
                      诊把脉”，提升办学质量</span
                    >
                  </div>
                </div>
                <div class="df df-c ai-c value-item">
                  <img
                    src="../../assets/img/home/value-2.png"
                    class="value-img"
                  />
                  <div class="title">对老师</div>
                  <div class="text">不改变教学习惯——轻松易操作</div>
                </div>
                <div class="df df-c ai-c value-item">
                  <img
                    src="../../assets/img/home/value-3.png"
                    class="value-img"
                  />
                  <div class="title">对学生/家长</div>
                  <div class="text">五育画像——长短板一目了然</div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <section id="four" class="four-section slidein-item slidein">
          <div class="section-title">
            四大亮点
            <img
              src="../../assets/img/home/title-label.png"
              class="title-label"
            />
          </div>
          <div class="df ai-c fours">
            <div
              class="four-box"
              :class="fourIndex == 1 ? 'f1 four-active' : ''"
              @mouseenter="fourIn(1)"
            >
              <div class="four-number">01</div>
              <div class="four-line"></div>
              <div class="four-title">指标特色</div>
              <div class="four-text">
                数据诊断到科学决策，发挥数据的导向性作用
              </div>
              <!-- <div class="arrow arrow-left df ai-c jc">
                <div class="arrow-border">
                  <i class="el-icon-back"></i>
                </div>
              </div>
              <div class="arrow arrow-right df ai-c jc">
                <div class="arrow-border">
                  <i class="el-icon-right"></i>
                </div>
              </div> -->
            </div>
            <div
              class="four-box"
              :class="fourIndex == 2 ? 'f2 four-active' : ''"
              @mouseenter="fourIn(2)"
            >
              <div class="four-number">02</div>
              <div class="four-line"></div>
              <div class="four-title">科研支撑</div>
              <div class="four-text">
                长达十年的课题支撑助力评价更加科学有效
              </div>
              <!-- <div class="arrow arrow-left df ai-c jc">
                <div class="arrow-border">
                  <i class="el-icon-back"></i>
                </div>
              </div>
              <div class="arrow arrow-right df ai-c jc">
                <div class="arrow-border">
                  <i class="el-icon-right"></i>
                </div>
              </div> -->
            </div>
            <div
              class="four-box"
              :class="fourIndex == 3 ? 'f3 four-active' : ''"
              @mouseenter="fourIn(3)"
            >
              <div class="four-number">03</div>
              <div class="four-line"></div>
              <div class="four-title">精准报告</div>
              <div class="four-text">
                数据诊断到科学决策，发挥数据的导向性作
              </div>
              <!-- <div class="arrow arrow-left df ai-c jc">
                <div class="arrow-border">
                  <i class="el-icon-back"></i>
                </div>
              </div>
              <div class="arrow arrow-right df ai-c jc">
                <div class="arrow-border">
                  <i class="el-icon-right"></i>
                </div>
              </div> -->
            </div>
            <div
              class="four-box"
              :class="fourIndex == 4 ? 'f4 four-active' : ''"
              @mouseenter="fourIn(4)"
            >
              <div class="four-number">04</div>
              <div class="four-line"></div>
              <div class="four-title">校本特色</div>
              <div class="four-text">
                特色激励卡，趣味化学生界面，期末个性化报告，为学校宣传品牌注入新活力
              </div>
              <!-- <div class="arrow arrow-left df ai-c jc">
                <div class="arrow-border">
                  <i class="el-icon-back"></i>
                </div>
              </div>
              <div class="arrow arrow-right df ai-c jc">
                <div class="arrow-border">
                  <i class="el-icon-right"></i>
                </div>
              </div> -->
            </div>
          </div>
        </section>
        <div id="case" class="slidein-item slidein" style="padding-top: 70px">
          <section class="case-section">
            <div class="case-wrapper">
              <div class="section-title">
                成功案例
                <img
                  src="../../assets/img/home/title-label.png"
                  class="title-label"
                />
              </div>
              <el-row :gutter="25" class="case-box">
                <el-col :span="4" v-for="item in 18" :key="item">
                  <div class="case-img">
                    <img :src="schoolUrl(item - 1)" alt="" />
                  </div>
                </el-col>
              </el-row>
            </div>
          </section>
        </div>
        <section id="connect" class="connect-section slidein-item slidein">
          <div class="section-title">
            联系咨询
            <img
              src="../../assets/img/home/title-label.png"
              class="title-label"
            />
          </div>
          <div class="connect-wrapper df ai-c jc-sb">
            <div>
              <el-form
                :model="ruleForm1"
                :rules="rules1"
                ref="ruleForm1"
                label-width="70px"
                class="contact-form"
              >
                <el-form-item
                  label="姓名"
                  prop="name"
                  class="contact-form-item"
                >
                  <el-input
                    type="text"
                    v-model="ruleForm1.name"
                    class="contact-form-input"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="手机号"
                  prop="mobile"
                  class="contact-form-item"
                >
                  <el-input
                    type="number"
                    v-model="ruleForm1.mobile"
                    class="contact-form-input"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="身份"
                  prop="value"
                  class="contact-form-item"
                >
                  <el-select
                    v-model="ruleForm1.value"
                    placeholder="请选择"
                    class="contact-form-input"
                  >
                    <el-option
                      v-for="list in typeList"
                      :key="list.code"
                      :label="list.name"
                      :value="list.code"
                      class="contact-form-input"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <div class="submit-button hover-blue" @click="submitForm1()">
                    提交
                  </div>
                </el-form-item>
              </el-form>
            </div>
            <img
              class="contact-img"
              src="../../assets/img/home/connect.png"
              width="372"
              height="372"
            />
          </div>
        </section>
        <!-- 登录卡片区域 -->
        <transition name="el-fade-in">
          <div class="login-bg-mask" v-show="loginShow">
            <el-card class="box_card" style="padding: 0px">
              <i
                class="el-icon-close close-icon"
                @click="loginShow = !loginShow"
              ></i>

              <div class="card_content">
                <!-- <div class="download-area">
                  <div style="height: 32px; width: 1px"></div>
                  <div class="download-area__item-wrap">
                    <div
                      class="download-area__item"
                      @mouseover="moveIn"
                      @mouseout="moveOut"
                    >
                      <img
                        class="download-area__item-qrcode"
                        src="../../assets/img/app-link.jpg"
                      />
                      <a class="download-area__item-intro" href="javascript:;">
                        <div
                          class="download-area__item-intro__logo micro"
                        ></div>
                        <span class="download-area__item-intro__txt"
                          >小程序</span
                        >
                      </a>
                    </div>
                    <div class="download-area__item-split-line"></div>
                  </div>
                  <div
                    class="download-area__item-wrap"
                    style="margin-top: 20px"
                  >
                    <div class="download-area__item">
                      <a
                        class="download-area__item-intro"
                        href="https://cdn.51xiaoping.com/download/pcxp/%E6%99%93%E8%AF%84%E7%BB%BC%E5%90%88%E8%AF%84%E4%BB%B7%20Setup%201.0.7.exe"
                      >
                        <div
                          class="download-area__item-intro__logo Windows"
                        ></div>
                        <span class="download-area__item-intro__txt"
                          >Windows下载</span
                        >
                      </a>
                    </div>
                  </div>
                </div>
                <div class="solid"></div> -->
                <!-- <div class="content_left"></div> -->
                <div class="content_right">
                  <!-- 右侧上部 -->
                  <div class="content_right_top">统一身份认证登录</div>
                  <div class="djhasiufag">
                    <span @click="ruleForm.region = 'teacher'"
                      >我是教师
                      <div v-if="ruleForm.region == 'teacher'"></div> </span
                    ><span @click="ruleForm.region = 'parent'"
                      >我是家长
                      <div v-if="ruleForm.region == 'parent'"></div
                    ></span>
                  </div>
                  <!-- 右侧下部表单区域 -->
                  <el-form
                    class="form_login"
                    ref="login"
                    :model="ruleForm"
                    :rules="formRiles"
                  >
                    <!-- <el-form-item class="form_select" prop="region">
                  <i class="iconp"
                    ><img
                      src="../../assets/img/login/shengfeng.png"
                      alt=""
                      srcset=""
                    />
                  </i>
                  <el-select
                    class="form_select_select"
                    v-model="ruleForm.region"
                    placeholder="请选择你的身份"
                    prefix-icon="el-icon-user"
                  >
                    <el-option label="学校管理员" value="school"></el-option>
                    <el-option label="教师" value="teacher"></el-option>
                    <el-option label="家长" value="parent"></el-option>
                  </el-select>
                </el-form-item> -->
                    <el-form-item prop="name">
                      <i class="iconp"
                        ><img
                          src="../../assets/img/login/shengfeng.png"
                          alt=""
                          srcset=""
                        />
                      </i>
                      <el-input
                        name="account"
                        v-model.trim="ruleForm.name"
                        placeholder="请输入用户名"
                      ></el-input>
                    </el-form-item>
                    <el-form-item prop="password" class="password-input">
                      <i class="iconp"
                        ><img
                          src="../../assets/img/login/mima.png"
                          alt=""
                          srcset=""
                        />
                      </i>
                      <el-input
                        v-model.trim="ruleForm.password"
                        type="password"
                        placeholder="请输入密码"
                        show-password
                        @keyup.enter.native="submitForm()"
                      ></el-input>
                    </el-form-item>
                    <div class="wanji" @click="goForget">忘记密码?</div>
                    <el-button
                      type="success"
                      @click="submitForm"
                      class="login-button"
                      >登录</el-button
                    >
                  </el-form>
                  <div
                    style="color: #0082ef; font-size: 20px"
                    v-if="ruleForm.region == 'teacher'"
                    class="sfasfafgas"
                    @click="dengs"
                  >
                    <img
                      class="imgshfaf"
                      src="../../assets/img/qwdl.png"
                      width="29px"
                    />
                    企业微信登录
                  </div>
                </div>
              </div>
            </el-card>
          </div>
        </transition>
      </el-main>
      <el-footer
        style="z-index: 88; background: #3d3e4a; width: 100%; height: 90px"
      >
        <div style="text-align: center">
          <!-- <img
            src="../../assets/img/home/logo.png"
            width="101"
            height="28"
            style="margin-top: 5px"
          /> -->
          <div class="footer-text">
            <img
              src="../../assets/img/home/2d1b12f6db56a8c30a67c8dc18d3ff9d@2x.png"
              class="new-logo"
              style="vertical-align: -50%"
            />
            <!-- 晓评学生评价 -->
          </div>
        </div>
        <!-- <div class="szjy">
          <div class="szjy_left"></div>
          <div class="szjy_content">开启素质教育美好新生态</div>
          <div class="szjy_right"></div>
        </div> -->
        <foo-ter></foo-ter>
      </el-footer>
    </el-container>
  </div>
</template>
<script>
import '../../assets/css/home.css'
import fooTer from '../footer/footer'
import { userlogin, zpUrl, dictCode, saveContactConsultation } from '@/api/home'
export default {
  components: {
    fooTer
  },
  data() {
    return {
      // 表单输入值
      loginShow: false,
      ruleForm: {
        region: 'teacher',
        name: '',
        password: ''
      },
      ruleForm1: {
        value: '',
        name: '',
        mobile: ''
      },
      //   token
      token: '',
      zpUrl: zpUrl,
      //   表单验证
      formRiles: {
        region: [{ required: true, message: '请选择角色', trigger: 'change' }],
        name: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      rules1: {
        value: [{ required: true, message: '请选择身份', trigger: 'blur' }],
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {
            required: true,
            pattern: /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/,
            message: '请输入正确的手机号码',
            trigger: 'blur'
          }
        ]
      },
      functionTList: [
        {
          name: '课堂评价',
          text: '激励卡、大屏点评、集优册等多种方式真正帮老师减负'
        },
        {
          name: '班级管理',
          text: '轻松搞定班级管理，让数据自动汇总分析'
        },
        {
          name: '活动参与',
          text: '海量活动模板，融入学校行事历，让活动过程精彩呈现'
        },
        {
          name: '特色课程',
          text: '参与社团、课后服务、研学等第二课堂过程激励，即时评价'
        },
        {
          name: '成长导师',
          text: '一生一导师，全师育人，助力孩子健康成长'
        },
        {
          name: '学业成绩',
          text: '成绩批量导入，自动转换等级，家校共享'
        },
        {
          name: '教师评语',
          text: '智能评语，评语更贴合学生实际、快速组合精准评语'
        },
        {
          name: '奖状授予',
          text: '智能推荐候选人，让评选更加精准'
        }
      ],
      functionSList: [
        {
          name: '成长树',
          text: '以“立德树人”为出发点，每学年可选一个树种，陪伴学生每个阶段'
        },
        {
          name: '活动参与',
          text: '融入学校行事历，让活动过程精彩呈现'
        },
        {
          name: '积分商店',
          text: '激发学习动机，他律变自律'
        },
        {
          name: '成长画像',
          text: '小卡大能量，真正帮老师减负'
        }
      ],
      typeList: [],
      ip: '',
      geolocation: '',
      teacherIndex: -1,
      studentIndex: 0,
      fourIndex: 1
    }
  },
  created() {
    // this.submitForm()
  },
  mounted() {
    this.dictCode()
    setTimeout(() => {
      this.getUserIp()
      this.getLocation()
    }, 500)
    this.initObserver('production')
    this.initObserver('proT')
    this.initObserver('proS')
    this.initObserver('value')
    this.initObserver('four')
    this.initObserver('case')
    this.initObserver('connect')
    window.addEventListener('scroll', () => {
      if (window.pageYOffset > 64) {
        document.getElementById('left-header').classList.add('black-text')
        document.getElementById('header-wrapper').classList.add('white-bg')
        let spans = document.getElementsByClassName('nav-span')
        for (let i = 0; i < spans.length; i++) {
          spans[i].classList.add('black-text')
        }
      } else {
        document.getElementById('left-header').classList.remove('black-text')
        document.getElementById('header-wrapper').classList.remove('white-bg')
        let spans = document.getElementsByClassName('nav-span')
        for (let i = 0; i < spans.length; i++) {
          spans[i].classList.remove('black-text')
        }
      }
    }) // 监听页面滚动
  },
  methods: {
    teacherIn(index) {
      this.teacherIndex = index
    },
    teacherOut() {
      // setTimeout(() => {
      //   this.teacherIndex = -1
      // }, 1000)
    },
    studentIn(index) {
      this.studentIndex = index
    },
    studentOut() {
      // setTimeout(() => {
      //   this.studentIndex = 0
      // }, 1000)
    },
    fourIn(index) {
      this.fourIndex = index
    },
    remove() {
      document.getElementById('function0').classList.remove('function-active')
      document.getElementById('functiontitle0').classList.remove('active-title')
      document.getElementById('functionline0').classList.remove('show-line')
      document.getElementById('functiontext0').classList.remove('show-text')
    },
    videoPlay() {
      this.$refs.bgVideo.play()
    },
    unmute() {
      this.$refs.bgVideo.muted = false
      this.$refs.bgVideo.play()
    },
    async dictCode() {
      const { data: res } = await dictCode({
        code: 'customer_identity'
      })
      this.typeList = res.data
    },
    schoolUrl(index) {
      return require(`../../assets/img/home/school-${index}.png`)
    },
    proUrl(index) {
      if (index == -1) {
        return require(`../../assets/img/home/pro--1.png`)
      }
      return require(`../../assets/img/home/pro-${index}.png`)
    },
    prosUrl(index) {
      return require(`../../assets/img/home/pros-${index}.png`)
    },
    getLocation() {
      let that = this
      AMap.plugin('AMap.Geolocation', function() {
        var geolocation = new AMap.Geolocation({
          enableHighAccuracy: true, // 是否使用高精度定位，默认:true
          timeout: 10000, // 超过10秒后停止定位，默认：无穷大
          maximumAge: 0, // 定位结果缓存0毫秒，默认：0
          convert: true // 自动偏移坐标，偏移后的坐标为高德坐标，默认：true
        })
        geolocation.getCurrentPosition((status, result) => {
          console.log(status, result)
          if (status == 'complete') {
            //获取用户当前的精确位置
            const {
              position: { KL, kT }
            } = result
            AMap.plugin('AMap.Geocoder', function() {
              var geocoder = new AMap.Geocoder({
                // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
                city: '010'
              })

              var lnglat = [KL, kT]
              console.log(lnglat)
              geocoder.getAddress(lnglat, function(status, result) {
                console.log(result)
                if (status === 'complete' && result.info === 'OK') {
                  that.geolocation = result.regeocode.formattedAddress
                }
              })
            })
          } else {
            console.log('获取位置失败')
          }
        })
      })
    },
    getUserIp() {
      let that = this
      var xhr = new XMLHttpRequest()
      xhr.open('GET', 'https://api.ipify.org', true)
      // 发送ajax请求
      xhr.send()
      xhr.onload = function() {
        that.ip = this.response
      }
      // if (typeof window != 'undefined') {
      //   var RTCPeerConnection =
      //     window.RTCPeerConnection ||
      //     window.mozRTCPeerConnection ||
      //     window.webkitRTCPeerConnection
      //   if (RTCPeerConnection)
      //     (() => {
      //       var rtc = new RTCPeerConnection()
      //       rtc.createDataChannel('') //创建一个可以发送任意数据的数据通道
      //       rtc.createOffer(
      //         (offerDesc) => {
      //           //创建并存储一个sdp数据
      //           rtc.setLocalDescription(offerDesc)
      //         },
      //         (e) => {
      //           console.log(e)
      //         }
      //       )
      //       rtc.onicecandidate = (evt) => {
      //         console.log(evt)
      //         //监听candidate事件
      //         if (evt.candidate) {
      //           // console.log('evt:', evt.candidate)
      //           let ip_rule =
      //             /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/
      //           var ip_addr = ip_rule.exec(evt.candidate.candidate)[1]
      //           this.ip = ip_addr
      //           // console.log('ip_addr:', ip_addr) //打印获取的IP地址
      //         }
      //       }
      //     })()
      //   else {
      //     console.log('没有找到')
      //   }
      // }
    },
    scrollTo(id) {
      let dom = document.getElementById(id)
      if (id == 'production' || id == 'welcome') {
        dom.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        })
        return
      }
      dom.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      })
    },
    initObserver(id) {
      let observer = new IntersectionObserver(res => {
        this.$nextTick(() => {
          if (res[0].boundingClientRect.y < 0) return
          let dom = document.getElementById(id)
          if (res[0].intersectionRatio <= 0) {
            dom.classList.remove('slidein')
          } else {
            dom.classList.add('slidein')
          }
        })
      })
      observer.observe(document.getElementById(id))
    },
    moveIn(e) {
      // console.log(e.currentTarget)
      // e.currentTarget.className =
      //   'download-area__item download-area__item--display'
    },
    moveOut(e) {
      e.currentTarget.className = 'download-area__item'
    },
    dengs() {
      let url = 'http://' + window.location.hostname + '/#/qywx/index'
      url = encodeURIComponent(url)
      window.location.href =
        'https://open.work.weixin.qq.com/wwopen/sso/3rd_qrConnect?appid=wwea25dbad39f04c7d&redirect_uri=' +
        url +
        '&usertype=member'
    },
    reset1() {
      this.ruleForm1.name = ''
      this.ruleForm1.mobile = ''
      this.ruleForm1.value = ''
    },
    submitForm1() {
      this.$refs.ruleForm1.validate(valid => {
        if (valid) {
          const params = {
            customerName: this.ruleForm1.name,
            customerMobile: this.ruleForm1.mobile,
            customerIdentity: this.ruleForm1.value,
            ipAddress: this.ip,
            ipAttribution: this.geolocation
          }
          saveContactConsultation(params).then(res => {
            if (res.data.code == 0) {
              this.$message.success('提交成功，我们会尽快与您联系')
              this.reset1()
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    submitForm() {
      this.$refs.login.validate(valid => {
        if (valid) {
          this.formHandler()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    async formHandler() {
      try {
        const { data: res } = await userlogin({
          roleType: this.ruleForm.region, //school
          // roleType: 'school',
          account: this.ruleForm.name,
          password: this.ruleForm.password
        })
        // 登录为学生的时跳转
        // if (this.ruleForm.roleType == 'student') {
        //   window.location.href = 'http://live.welaiedu.cn/#/?token=' + res.token
        // }
        // 第一次登录时
        if (res.data.isSettingPwdQuestion == 0) {
          // 添加token到localStorage
          window.localStorage.setItem('token', res.data.token)
          // 添加登录ID到localStorage
          localStorage.setItem('userId', res.data.userId)
          localStorage.setItem('schoolIds', res.data.userId)
          // 添加roleType到localStorage
          localStorage.setItem('roleType', res.data.roleType)
          localStorage.setItem('roleTypes', res.data.roleType)
          this.$message.info(
            '检测到您尚未设置密保问题,需要先设置密保问题。设置完密保问题系统会帮您自动登录'
          )
          this.$router.push('/user/checkFirstlogin')
        } else {
          if (this.ruleForm.region == 'parent') {
            window.open(
              zpUrl +
                '?token=' +
                res.data.token +
                '&roleId=' +
                res.data.roleList[0].id
            )
            return false
          }
          // 添加token到localStorage
          window.localStorage.setItem('token', res.data.token)
          // 添加登录ID到localStorage
          localStorage.setItem('userId', res.data.userId)
          localStorage.setItem('schoolIds', res.data.userId)
          // 添加roleType到localStorage
          localStorage.setItem('roleType', res.data.roleType)
          localStorage.setItem('roleTypes', res.data.roleType)
          // 提示登录成功
          this.$message({
            message: '登录成功',
            type: 'success'
          })
          // 跳转到工作台
          this.$router.push('/bench')
        }
      } catch (err) {
        console.log(err)
      }
    },
    goForget() {
      this.$router.push('/forget')
    }
  }
}
</script>
<style scoped>
.contact-form {
  margin-top: 50px;
}
.contact-form-item {
  margin-bottom: 25px;
}
.contact-form-input {
  width: 300px !important;
}
.header-logo {
  width: 101px;
  height: 28px;
}
.new-logo {
  width: 34.2px;
  height: 33.2px;
}
#login {
  overflow: hidden;
}

.page_login {
  background-color: #f0f2f5;
  width: 100%;
  min-width: 800px;
  position: relative;
}

/* 卡片区域样式 */

.box_card {
  width: 450px;
  height: 430px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  /* bottom: calc(12vw + 70px);
  left: 0;
  right: 0; */
  /* margin: auto; */
  background-color: #fff;
  border-radius: 20px;
  z-index: 99;
}

.card_content {
  width: 450px;
  height: 430px;
  /* padding-top: 35px; */
  border-radius: 10px;
  /* background-color:red; */
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.card_content .content_left {
  width: 525px;
  height: 490px;
  background: #fff url('../../assets/img/login/left_image.e43f246f.png')
    no-repeat 100% 100%;
}

.card_content .content_right {
  margin: 30px auto;
  width: 400px;
  /* height: 400px; */
  /* border: 1px solid #dcdfe6; */
}

.content_right_top {
  /* height: 80px; */
  font-size: 30px;
  color: #4887ff;
  letter-spacing: 6px;
  /* padding-left: 20px; */
  text-align: center;
  margin-bottom: 15px;
  /* background: #fff url('../../assets/img/login/right-top-text.png'); */
}

.content_right .form_login {
  margin: 20px;
}

.el-scrollbar__view {
  padding: 10px;
}

.form_select {
  width: 100%;
}

.form_select_select {
  width: 360px;
}

.el-select-dropdown__item {
  padding-left: 10px;
  width: 360px;
}

.content_right .login-button {
  width: 100%;
  height: 40px;
  border-radius: 20px;
  margin-top: 20px;
}

.wanji {
  width: 60px;
  font-size: 12px;
  margin-top: 18px;
  color: #ababab;
  cursor: pointer;
}
.iconp {
  position: absolute;
  top: 5px;
  left: 10px;
  z-index: 10;
}
.szjy {
  width: 350px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #ffffff;
  letter-spacing: 1.23px;
}
.szjy_left {
  height: 0px;
  width: 60px;
  border: 1px solid #fff;
}
.szjy_content {
  font-size: 16px;
}
.szjy_right {
  height: 0px;
  width: 60px;
  border: 1px solid #fff;
}
.imgshfaf {
  vertical-align: middle;
}
.sfasfafgas {
  cursor: pointer;
  text-align: center;
}
.download-area {
  /* position: absolute;
  bottom: 70px;
  left: 0;
  right: 0; */
  margin: 0px 20px;
  height: 100%;
  padding: 30px 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  /* justify-content: center; */
  justify-content: space-between;
  flex-direction: column;
  z-index: 100;
}
.download-area,
.download-area__item {
  /* height: 11.22vw; */
  display: flex;
  align-items: center;
}
.download-area__item-wrap {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}
.download-area__item {
  position: relative;
  /* width: 9.52vw; */
  width: 185px;
  /* display: flex;
  align-items: center; */
  flex-direction: column;
  justify-content: flex-end;
  /* margin: 0 1.105vw; */
  /* border: 0.085vw solid transparent; */
}
.download-area__item--display {
  background: hsla(0, 0%, 100%, 0.88);
  border: 0.085vw solid hsla(0, 0%, 100%, 0.8);
  box-shadow: 0 0.85vw 2.04vw rgb(0 0 0 / 6%);
  -webkit-backdrop-filter: blur(0.85vw);
  backdrop-filter: blur(0.85vw);
  border-radius: 0.51vw;
  z-index: 11;
}
.download-area__item-split-line {
  content: '';
  position: relative;
  margin-bottom: 0.85vw;
  width: 0.085vw;
  height: 1.53vw;
  background: #fff;
  mix-blend-mode: normal;
  opacity: 0.1;
  border-radius: 0.34vw;
}
.download-area__item-intro {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  /* margin-bottom: 0.85vw; */
}
.download-area__item-intro__txt {
  position: relative;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  /* font-size: 1.19vw;
  line-height: 1.7vw; */
  /* color: #fff; */
  color: #09f;
}
.download-area__item-qrcode {
  position: relative;
  width: 130px;
  height: 130px;
  margin-bottom: 15px;
}
.download-area__item:hover .download-area__item-qrcode {
  display: block;
}
.download-area__item:hover .download-area__item-intro__txt {
  color: #09f;
}

.download-area__item-intro__logo {
  overflow: hidden;
  position: relative;
  height: 32px;
  width: 32px;
  margin-right: 10px;
  /* width: 1.7vw;
  height: 1.7vw; */
  /* margin-right: 0.51vw; */
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50%;
}
.download-area__item:hover .download-area__item-intro__logo.Windows {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEVSURBVHgB7dsxSsRQGEbRP6MLGfcmDK5oENybuhEjIxZ2ksb7wHOqlI/ckKT5ZgAAAAD4L7Y56nnfZwV3c57H7f3r+rqf5zSvs4LLduienoaUADEBYgLEBIgJEBMgJkBMgJgAMQFiAsQEiAkQEyAmQEyAmAAxAWICxASICRATICZATICYADEBYgLEBIgJEBMgJkBMgNj9HPUxD7OCy/c65uZpe5vrvsa5gAOOj/Rug7gV3F47P616rl8c/wasskZ82ddcSR58qP0FxQSICRATICZATICYADEBYgLEBIgJEBMgJkBMgJgAMQFiAsQEiAkQEyAmQEyAmAAxAWICxASICRATICZATICYADEBYgIAAAAAwB/5BCPxGXK43YEEAAAAAElFTkSuQmCC);
}
/* .download-area__item .download-area__item-intro__logo.Windows {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEFSURBVHgB7dtBSsRAEEDRiniQeP9DqSeJGVBwpcSFv4d5b5MOZFHkQ+9qBgAAAIBHsc1Fx2nWsG/b9n47nCPt5+N1FnDOdOmfPg0pAWICxASICRATICZATICYADEBYgLEBIgJEBMgJkBMgJgAMQFiAsQEiAkQEyAmQEyAmAAxAWICxASICRATICZATICYALHnue5lFvC1HfN5fjuOY4m5gCv+sqS3zwJu187391Xn+vX7uciW5M9sSd4ZAWICxASICRATICZATICYADEBYgLEBIgJEBMgJkBMgJgAMQFiAsQEiAkQEyAmQEyAmAAxAWICxASICRATICZATICYAAAAAADwTz4AVaofklm/waMAAAAASUVORK5CYII=);
} */
.download-area__item .download-area__item-intro__logo.Windows {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEVSURBVHgB7dsxSsRQGEbRP6MLGfcmDK5oENybuhEjIxZ2ksb7wHOqlI/ckKT5ZgAAAAD4L7Y56nnfZwV3c57H7f3r+rqf5zSvs4LLduienoaUADEBYgLEBIgJEBMgJkBMgJgAMQFiAsQEiAkQEyAmQEyAmAAxAWICxASICRATICZATICYADEBYgLEBIgJEBMgJkBMgNj9HPUxD7OCy/c65uZpe5vrvsa5gAOOj/Rug7gV3F47P616rl8c/wasskZ82ddcSR58qP0FxQSICRATICZATICYADEBYgLEBIgJEBMgJkBMgJgAMQFiAsQEiAkQEyAmQEyAmAAxAWICxASICRATICZATICYADEBYgIAAAAAwB/5BCPxGXK43YEEAAAAAElFTkSuQmCC);
}

.download-area__item:hover .download-area__item-intro__logo.micro {
  background-image: url(data:image/png;base64,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);
}
/* .download-area__item .download-area__item-intro__logo.micro {
  background-image: url(data:image/png;base64,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);
} */
.download-area__item .download-area__item-intro__logo.micro {
  background-image: url(data:image/png;base64,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);
}
.password-input {
  margin-top: 20px;
}
.flex_box {
  display: flex;
  algin-item: flex-end;
}
.solid {
  width: 1px;
  height: 360px;
  border-right: 1px solid #c9c9c9;
  margin-top: 5px;
}
.login-bg-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 999;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}
.close-icon {
  position: absolute;
  top: 24px;
  right: 24px;
  cursor: pointer;
  font-size: 16px;
}
.welcome-wrapper {
  position: relative;
  width: 100%;
  /* min-width: 1360px;
  min-height: 467.5px;
  padding-bottom: 34.375%; */
  /* min-width: 800px;
  min-height: 450px; */
  padding-bottom: 56.25%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background: url(../../assets/img/home/welcome-bg2.png) no-repeat;
  background-size: 100% 100%;
}
.left-box {
  background: url(../../assets/img/home/windows.png) no-repeat;
  background-size: 100%;
}
.right-box {
  background: url(../../assets/img/home/qrcode.png) no-repeat;
  background-size: 100%;
  margin-left: 40px;
}
.bg-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 10px;
}
.header-wrapper {
  position: fixed;
  z-index: 999;
  top: 0;
  width: 100%;
  transition: all 0.4s;
}
.header-wrapper .header {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  position: relative;
  height: 64px;
  color: #fff;
}
.left-header {
  height: 100%;
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  position: absolute;
  left: 80px;
  top: 0;
}
.right-header {
  position: absolute;
  right: 80px;
  top: 32px;
  margin-top: -16px;
}
.submit-button {
  width: 150px;
  height: 40px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 7px;
  background: #4ec5ae;
  color: #fff;
  font-weight: 600;
  font-size: 14px;
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  cursor: pointer;
  border: none;
}
.login-wrapper {
}
.login-wrapper .login-button {
  width: 78px;
  height: 39px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 7px;
  background: #4ec5ae;
  color: #fff;
  font-weight: 600;
  font-size: 14px;
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  cursor: pointer;
  border: none;
  -webkit-transition: all 0.25s ease;
  transition: all 0.25s ease;
}
a {
  text-decoration: none;
  background-color: transparent;
  color: #333;
  font-weight: 500;
  font-size: 14px;
}
.nav {
  margin: 0;
  padding: 0;
  list-style: none;
  padding-left: 44px;
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}
.nav li {
  margin: 0 24px;
  padding: 8px 0;
  overflow: hidden;
  display: inline-block;
  position: relative;
}
.nav li span {
  /* color: #333; */
  font-weight: 500;
  font-size: 14px;
  user-select: none;
  cursor: pointer;
}
.intro {
  width: 800px;
  position: absolute;
  top: 20%;
  left: 50%;
  margin-left: -580px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  z-index: 1;
}
.welcome-wrapper .intro .title {
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 40px;
  line-height: 68px;
  letter-spacing: 0.923077px;
  color: #fff;
  margin: 0 0 32px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
}
.download-box {
  width: 164px;
  height: 197px;
  /* background: rgba(255, 255, 255, 0.31); */
  border-radius: 12px;
  padding: 135px 20px 0;
  box-sizing: border-box;
}
.download-button {
  width: 125px;
  height: 40px;
  background: #4ec5ae;
  border-radius: 28px;
  text-align: center;
  line-height: 40px;
  font-size: 20px;
  /* font-weight: 600; */
  color: #ffffff;
  cursor: pointer;
  user-select: none;
  -webkit-transition: all 0.25s ease;
  transition: all 0.25s ease;
}
.download-windows {
  font-size: 18px;
  font-weight: 600;
  color: #333333;
}
.download-windows-text {
  margin-top: 10px;
  margin-bottom: 15px;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  color: #333333;
}
.download-qrcode {
  width: 95px;
  height: 95px;
}
.download-qrcode-text {
  text-align: center;
  font-size: 24px;
  /* font-weight: 600; */
  color: #fff;
}
.video-section {
  width: 1300px;
  height: fit-content;
  margin: 80px auto 0px;
}
.video-box {
  position: relative;
  width: 660px;
  height: 371.25px;
  /* width: 600px;
  height: 337.5px; */
  /* padding-bottom: 56.25%; */
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.production-section {
  width: 1300px;
  margin: 0px auto 0px;
  padding-top: 70px;
}
.value-section {
  width: 100%;
  position: relative;
  /* min-width: 800px;
  min-height: 258.4px; */
  padding-bottom: 32.3%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background: url(../../assets/img/home/value-bg.png);
  background-size: contain;
}
.four-section {
  width: 1300px;
  margin: 0px auto 0px;
  padding-top: 70px;
}
.case-section {
  width: 100%;
  position: relative;
  /* min-width: 800px;
  min-height: 258.4px; */
  padding-bottom: 32.3%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  /* background: #000000; */
}
.connect-section {
  width: 1300px;
  margin: 0px auto 0px;
  padding-top: 70px;
  padding-bottom: 120px;
}
.slidein-item {
  position: relative;
  opacity: 0;
  top: 100px;
  /* transform: translateY(10%); */
  transition: all 0.4s ease-in-out;
}
.slidein-item.slidein {
  opacity: 1;
  top: 0;
  /* transform: translateY(0); */
}
.function-box {
  width: 118px;
  height: 350px;
  border-radius: 10px;
  transition: width 0.4s;
  margin-right: 20px;
  background-size: contain;
  padding: 40px 16px;
  box-sizing: border-box;
  background-repeat: no-repeat;
}
.function-box:hover {
  width: 275px;
  height: 350px;
  background: #376aff !important;
}
.function-active {
  width: 275px;
  height: 350px;
  background: #376aff !important;
}
.function-title {
  font-size: 20px;
  font-weight: bold;
  color: #5988c0;
}
.function-box:hover .function-title {
  color: #fff;
}
.function-active .active-title {
  color: #fff;
}
.function-line {
  width: 32px;
  height: 6px;
  background: #ffffff;
  border-radius: 3px;
  margin: 15px 0 20px;
  opacity: 0;
}
.show-line {
  opacity: 1;
}
.function-box:hover .function-line {
  opacity: 1;
}
.function-text {
  font-size: 18px;
  font-weight: 500;
  color: #ffffff;
  opacity: 0;
}
.show-text {
  opacity: 1;
}
.function-box:hover .function-text {
  opacity: 1;
}
.section-title {
  /* text-align: center; */
  font-size: 36px;
  /* font-weight: bold; */
  color: #333333;
}
.value-wrapper {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: 1300px;
  height: fit-content;
  color: #ffffff;
}
.value-wrapper .title {
  margin: 5px 0 15px;
  font-size: 20px;
  font-weight: bold;
}
.value-wrapper .text {
  text-align: center;
  font-size: 16px;
  /* height: 63px; */
}
.case-wrapper {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: 1300px;
  height: fit-content;
  color: #ffffff;
}
.four-box {
  width: 280px;
  height: 335px;
  transition: all 0.4s;
  margin-right: 10px;
  position: relative;
  box-sizing: border-box;
  padding: 35px 30px;
  color: #fff;
  background: #f7f8fc;
}
.four-box:last-child {
  margin-right: 0;
}
.four-number {
  font-size: 60px;
  font-weight: bold;
  color: #d8dbe4;
}
.four-line {
  width: 32px;
  height: 6px;
  background: #ffffff;
  border-radius: 3px;
  margin-left: 5px;
  opacity: 0;
}
.four-title {
  font-size: 22px;
  font-weight: 500;
  color: #666666;
  margin: 10px 0;
}
.four-text {
  font-size: 16px;
  font-weight: 400;
  opacity: 0;
}
.text-active {
  color: #fff;
}
.arrow {
  width: 32px;
  height: 32px;
  background: #ffffff;
  border-radius: 50%;
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
  z-index: 1;
  opacity: 0;
}
.arrow-border {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 1px solid #376aff;
  color: #376aff;
  text-align: center;
  line-height: 28px;
}
.arrow-left {
  left: -16px;
}
.arrow-right {
  right: -16px;
}
.black-text {
  color: #333;
}
.white-bg {
  background: #fff;
  box-shadow: 0 -20px 50px 0px rgba(0, 0, 0, 0.3);
}
.title-label {
  width: 22px;
  height: 27px;
  margin-bottom: 5px;
}
.value-img {
  width: 110px;
  height: 110px;
}
.footer-text {
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
  padding: 10px 0;
}
.case-img {
  width: 100%;
  position: relative;
  padding-bottom: 43.3%;
  display: inline-block;
  margin-bottom: 20px;
}
.case-img img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.hover-blue:hover {
  background: rgba(78, 197, 174, 0.8);
}
.video-text {
  color: #333333;
}
.vt-right {
  text-align: right;
  margin: 15px 0 20px;
}
.video-text-img {
  width: 158px;
  height: 39px;
}
.video-button {
  width: 147px;
  height: 62px;
  position: relative;
  cursor: pointer;
  margin: 0 auto;
  background-image: url(../../assets/img/home/video-button.png);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50%;
}
/* .video-button::after {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  transform: scale(0);
  transition: transform 0.5;
  z-index: 1;
}  */
/* .video-button:hover::after {
  transform: scale(1);
} */
.four-active {
  width: 428px;
  height: 339px;
}
.four-active .four-number {
  color: #fff;
}
.four-active .four-title {
  color: #fff;
}
.four-active .four-text {
  opacity: 1;
}
.four-active .four-line {
  opacity: 1;
}
.f1 {
  background: url(../../assets/img/home/four-1.png);
  background-size: 100% 100%;
}
.f2 {
  background: url(../../assets/img/home/four-2.png);
  background-size: 100% 100%;
}
.f3 {
  background: url(../../assets/img/home/four-3.png);
  background-size: 100% 100%;
}
.f4 {
  background: url(../../assets/img/home/four-4.png);
  background-size: 100% 100%;
}
@keyframes op {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.production-title {
  font-size: 28px;
  color: #333333;
  margin-bottom: 30px;
  text-align: center;
}
.production-img {
  width: 500px;
  height: 500px;
}
.production-img img {
  width: 500px;
  height: 500px;
  animation: op 3s ease;
}
.production-item {
  width: 185px;
  height: 200px;
  background-color: #f7f8fc;
  border-radius: 9px;
  padding: 40px 20px 30px;
  box-sizing: border-box;
  margin-right: 10px;
  margin-bottom: 20px;
}
.production-item:nth-child(4n) {
  margin-right: 0;
}
.production-item .item-title {
  font-size: 20px;
  color: #000000;
  text-align: center;
}
.production-item .item-text {
  font-size: 16px;
  color: #999999;
  text-align: center;
}
.production-item .item-line {
  width: 18px;
  height: 6px;
  background: linear-gradient(138deg, #2de6c5 0%, #14c893 100%);
  border-radius: 3px;
  margin: 10px auto;
}
.production-item .line-active {
  background: #fff;
}
.production-item .item-active {
  color: #fff;
}
.bg-active {
  background: linear-gradient(138deg, #2de6c5 0%, #14c893 100%);
}
.nav-span:hover {
  opacity: 0.7;
}
img {
  -webkit-user-drag: none;
}
.value-items {
  margin-top: 60px;
  align-items: flex-start;
}
.value-item {
  margin-left: 100px;
}
.value-item:first-child {
  margin-left: 0;
}
.pro-title {
  font-size: 24px;
  color: #93a4b1;
  margin-top: 20px;
  margin-bottom: 30px;
}
.pro-title span {
  font-size: 18px;
}
.production-box {
  width: 800px;
  flex-wrap: wrap;
}
.parent-box {
  margin-top: 40px;
}
.video-left {
  width: 240px;
  padding-top: 80px;
}
.fours {
  margin-top: 75px;
}
.case-box {
  margin-top: 60px;
}
.connect-wrapper {
  width: 1000px;
  margin: 0 auto;
}
@media screen and (max-width: 1400px) {
  .intro {
    margin-left: -500px;
  }

  .welcome-wrapper .intro .title {
    font-size: 36px;
  }

  .download-box {
    padding-top: 145px;
  }

  .download-button {
    width: 115px;
    height: 35px;
    line-height: 35px;
    font-size: 18px;
  }

  .download-qrcode-text {
    font-size: 20px;
  }

  .section-title {
    font-size: 30px;
  }

  .title-label {
    margin-bottom: 0;
  }

  .video-section {
    width: 1000px;
  }

  .video-left {
    width: 220px;
    padding-top: 60px;
  }

  .video-box {
    width: 550px;
    height: 309.375px;
  }

  .production-section {
    width: 1000px;
  }

  .pro-title {
    font-size: 20px;
  }

  .pro-title span {
    font-size: 16px;
  }

  .parent-box {
    margin-top: 20px;
  }

  .production-box {
    width: 690px;
  }

  .production-img {
    width: 300px;
    height: 300px;
  }

  .production-img img {
    width: 300px;
    height: 300px;
  }

  .production-title {
    font-size: 24px;
  }

  .production-item {
    width: 165px;
    height: 180px;
    padding: 30px 15px 20px;
  }

  .production-item .item-title {
    font-size: 18px;
  }

  .production-item .item-text {
    font-size: 14px;
  }

  .four-section {
    width: 1000px;
  }

  .connect-section {
    width: 1000px;
  }

  .case-wrapper {
    width: 1000px;
  }

  .value-wrapper {
    width: 1000px;
  }

  .value-section .value-item {
    margin-left: 50px;
  }

  .value-section .value-item:first-child {
    margin-left: 0;
  }

  .value-section .value-item .value-img {
    width: 90px;
    height: 90px;
  }

  .value-section .value-item .title {
    font-size: 18px;
  }

  .value-section .value-item .text {
    font-size: 14px;
  }
  .fours {
    scale: 0.8;
    transform: translate(-100px, -60px);
  }
}
@media screen and (max-width: 1200px) {
  .left-header {
    left: 40px;
  }

  .intro {
    margin-left: -350px;
  }

  .download-box {
    scale: 0.8;
  }

  .login-wrapper {
    scale: 0.8;
  }
  .nav {
    padding-left: 30px;
  }
  .nav li {
    margin: 0 14px;
  }
  .right-header {
    right: 40px;
  }

  .welcome-wrapper .intro .title {
    font-size: 30px;
  }

  .download-box {
    padding-top: 145px;
    margin-left: -20px;
  }

  .right-box {
    margin-left: 20px;
  }

  .download-button {
    width: 115px;
    height: 35px;
    line-height: 35px;
    font-size: 18px;
  }

  .download-qrcode-text {
    font-size: 20px;
  }

  .section-title {
    font-size: 26px;
  }

  .title-label {
    margin-bottom: 5px;
    vertical-align: middle;
  }

  .video-section {
    width: 800px;
  }

  .video-box {
    width: 500px;
    height: 281.25px;
  }

  .video-left {
    scale: 0.8;
  }

  .production-section {
    width: 800px;
  }

  .pro-title {
    font-size: 16px;
  }

  .pro-title span {
    font-size: 14px;
  }

  .parent-box {
    margin-top: 20px;
  }

  #proT {
    scale: 0.8;
    transform: translate(-100px);
  }

  #proS {
    scale: 0.8;
    transform: translate(-100px, -80px);
  }

  .production-box {
    width: 690px;
  }

  .production-img {
    width: 300px;
    height: 300px;
  }

  .production-img img {
    width: 300px;
    height: 300px;
  }

  .production-title {
    font-size: 20px;
  }

  .production-item {
    width: 165px;
    height: 180px;
    padding: 30px 15px 20px;
  }

  .production-item .item-title {
    font-size: 18px;
  }

  .production-item .item-text {
    font-size: 14px;
  }

  .four-section {
    width: 800px;
  }

  .connect-section {
    width: 800px;
  }

  .case-wrapper {
    width: 800px;
  }

  .value-wrapper {
    width: 800px;
  }

  .value-items {
    margin-top: 20px;
  }

  .value-section .value-item {
    margin-left: 50px;
    flex: 1;
  }

  .value-section .value-item:first-child {
    margin-left: 0;
  }

  .value-section .value-item .value-img {
    width: 60px;
    height: 60px;
  }

  .value-section .value-item .title {
    font-size: 18px;
  }

  .value-section .value-item .text {
    font-size: 12px;
  }
  .connect-wrapper {
    width: 100%;
  }
  .connect-wrapper .contact-img {
    width: 279px;
    height: 279px;
  }

  .value-section br {
    display: none;
  }
  #value {
    padding-top: 0px !important;
  }
  #case {
    padding-top: 0px !important;
  }
}
@media screen and (max-width: 1000px) {
  .left-header {
    left: 40px;
  }

  .intro {
    margin-left: -350px;
  }

  .download-box {
    scale: 0.8;
  }

  .login-wrapper {
    scale: 0.8;
  }
  .nav {
    padding-left: 30px;
  }
  .nav li {
    margin: 0 14px;
  }
  .right-header {
    right: 40px;
  }

  .welcome-wrapper .intro .title {
    font-size: 30px;
  }

  .download-box {
    padding-top: 145px;
    margin-left: -20px;
  }

  .right-box {
    margin-left: 20px;
  }

  .download-button {
    width: 115px;
    height: 35px;
    line-height: 35px;
    font-size: 18px;
  }

  .download-qrcode-text {
    font-size: 20px;
  }

  .section-title {
    font-size: 26px;
  }

  .title-label {
    margin-bottom: 5px;
    vertical-align: middle;
  }

  .video-section {
    width: 800px;
  }

  .video-box {
    width: 500px;
    height: 281.25px;
  }

  .video-left {
    scale: 0.8;
  }

  .production-section {
    width: 800px;
  }

  .pro-title {
    font-size: 16px;
  }

  .pro-title span {
    font-size: 14px;
  }

  .parent-box {
    margin-top: 20px;
  }

  #proT {
    scale: 0.8;
    transform: translate(-100px);
  }

  #proS {
    scale: 0.8;
    transform: translate(-100px);
  }

  .production-box {
    width: 690px;
  }

  .production-img {
    width: 300px;
    height: 300px;
  }

  .production-img img {
    width: 300px;
    height: 300px;
  }

  .production-title {
    font-size: 20px;
  }

  .production-item {
    width: 165px;
    height: 180px;
    padding: 30px 15px 20px;
  }

  .production-item .item-title {
    font-size: 18px;
  }

  .production-item .item-text {
    font-size: 14px;
  }

  .four-section {
    width: 800px;
  }

  .connect-section {
    width: 800px;
  }

  .case-wrapper {
    width: 800px;
  }

  .value-wrapper {
    width: 800px;
  }

  .value-items {
    margin-top: 20px;
  }

  .value-section .value-item {
    margin-left: 50px;
    flex: 1;
  }

  .value-section .value-item:first-child {
    margin-left: 0;
  }

  .value-section .value-item .value-img {
    width: 60px;
    height: 60px;
  }

  .value-section .value-item .title {
    font-size: 18px;
  }

  .value-section .value-item .text {
    font-size: 12px;
  }

  .connect-wrapper .contact-img {
    width: 279px;
    height: 279px;
  }

  .value-section br {
    display: none;
  }
}
@media screen and (max-width: 800px) {
  .page_login {
    min-width: 600px;
  }
}
@media screen and (max-width: 400px) {
  .left-header {
    left: 10px;
    scale: 1;
  }
  .header-logo {
    width: calc(101px * 0.6);
    height: calc(28px * 0.6);
  }
  .nav {
    padding-left: 10px;
  }
  .nav li {
    margin: 0 4px;
  }

  .intro {
    margin-left: -40%;
    top: 30%;
  }

  .download-box {
    scale: 1;
    width: calc(164px * 0.4);
    height: calc(197px * 0.4);
    padding: 55px 10px 0;
    margin-left: 0;
  }
  .right-box {
    margin-left: 10px;
  }

  .login-wrapper {
    scale: 0.8;
  }
  .welcome-wrapper .intro {
    width: 80vw;
  }
  .welcome-wrapper .intro .title {
    font-size: 12px;
    line-height: 20px;
    margin-bottom: 10px;
  }

  .download-button {
    width: calc(115px * 0.4);
    height: calc(35px * 0.4);
    line-height: calc(35px * 0.4);
    font-size: 6px;
  }

  .download-qrcode-text {
    font-size: 6px;
  }

  .section-title {
    font-size: 18px;
  }

  .title-label {
    width: calc(22px * 0.4);
    height: calc(27px * 0.4);
  }

  .video-section {
    width: 90%;
    margin-top: 30px;
  }

  .video-box {
    width: 150px;
    height: 84.375px;
  }
  .video-text-img {
    width: calc(158px * 0.4);
    height: calc(39px * 0.4);
  }
  .video-left {
    scale: 1;
    width: 140px;
    padding-top: 10px;
  }
  .video-button {
    width: calc(147px * 0.4);
    height: calc(62px * 0.4);
  }

  .production-section {
    width: 90%;
  }

  .pro-title {
    font-size: 10px;
    margin: 10px 0 15px;
  }

  .pro-title span {
    font-size: 8px;
  }
  #proT {
    scale: 1;
    transform: translate(0);
  }
  #proS {
    scale: 1;
    transform: translate(0);
  }
  .parent-box {
    margin-top: 20px;
  }

  .production-box {
    width: 215px;
  }

  .production-img {
    width: 130px;
    height: 130px;
  }

  .production-img img {
    width: 130px;
    height: 130px;
  }

  .production-title {
    font-size: 10px;
    margin-bottom: 15px;
  }

  .production-item {
    width: calc(165px * 0.4);
    height: calc(180px * 0.5);
    padding: 10px 7px 8px;
    margin-right: 5px;
    margin-bottom: 10px;
  }
  .production-item:nth-child(4n) {
    margin-right: 5px;
  }
  .production-item:nth-child(3n) {
    margin-right: 0px;
  }

  .production-item .item-title {
    font-size: 7px;
  }

  .production-item .item-text {
    font-size: 5px;
  }
  .production-item .item-line {
    width: 9px;
    height: 3px;
    margin: 5px auto;
  }

  .four-section {
    width: 90%;
    padding-top: 20px;
  }

  .connect-section {
    width: 90%;
    padding-top: 30px;
  }

  .case-wrapper {
    width: 90%;
  }

  .value-wrapper {
    width: 90%;
  }

  .value-items {
    margin-top: 5px;
  }

  .value-section .value-item {
    margin-left: 50px;
    flex: 1;
  }

  .value-section .value-item:first-child {
    margin-left: 0;
  }

  .value-section .value-item .value-img {
    width: 20px;
    height: 20px;
  }

  .value-section .value-item .title {
    font-size: 7px;
    margin: 5px 0 7px;
  }

  .value-section .value-item .text {
    font-size: 5px;
  }

  .connect-wrapper .contact-img {
    width: 0px;
    height: 0px;
    display: none;
  }
  .value-section {
    padding-bottom: 56.25%;
  }
  .value-section br {
    display: none;
  }
  .value-section span {
    display: none;
  }
  .fours {
    scale: 1;
    transform: translate(0, 0);
    margin-top: 15px;
  }
  .connect-section form {
    scale: 1;
    transform: translate(0, 0);
  }
  .nav li span {
    font-size: 8px;
  }
  .right-header {
    right: 10px;
    margin-top: -10px;
    display: none;
  }
  .login-wrapper {
    scale: 1;
  }
  .login-wrapper .login-button {
    width: 45px;
    height: 22.5px;
    line-height: 22.5px;
    border-radius: 5px;
    font-size: 8px;
  }
  .page_login {
    min-width: 300px;
  }
  .vt-right {
    margin: 5px 0 10px;
  }
  .four-box {
    width: calc(280px * 0.4);
    height: calc(335px * 0.4);
    padding: 15px 10px;
    overflow: hidden;
  }
  .four-active {
    width: calc(428px * 0.4);
    height: calc(339px * 0.4);
  }
  .four-number {
    font-size: 20px;
  }
  .four-line {
    width: 14px;
    height: 2px;
    background: #ffffff;
    border-radius: 1.5px;
    margin-left: 1px;
  }
  .four-title {
    font-size: 11px;
  }
  .four-text {
    font-size: 7px;
  }
  .case-box {
    margin-top: 10px;
  }
  #case {
    padding-top: 30px !important;
  }
  .contact-form {
    margin-top: 10px;
  }
  .contact-form-item {
    margin-bottom: 10px;
  }
  .contact-form-input {
    width: 200px !important;
  }
  .header-wrapper .header {
    height: 30px;
  }
  #value {
    padding-top: 30px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/home.vue